import React, { useState, useEffect } from 'react';
import {
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Grid,
  ListItemIcon,
  Button,
} from '@mui/material';
import PropTypes from 'prop-types';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Colors } from '../../../landingPage/style/theme';

IpCurrencySubscriptionPage.propTypes = {
  openForm: PropTypes.func,
  openPurchaseForm: PropTypes.func,
};

export default function IpCurrencySubscriptionPage(props) {
  const [ipQualitySubscriptionPlans, setIpQualitySubscriptionPlans] = useState([]);
  const navigate = useNavigate();

  // Fetch subscription plans from API
  useEffect(() => {
    const fetchIpQualitySubscriptionPlans = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/getSubscriptionsByApi?apiTitle=IP_TO_CURRANCYANDLOCATION`
        );

        const plans = response.data.data || [];

        // Sort the plans by subscriptionTitle order: Basic -> Standard -> Advance
        const sortedPlans = plans.sort((a, b) => {
          const order = ['Basic', 'Standard', 'Advance'];
          return order.indexOf(a.subscriptionTitle) - order.indexOf(b.subscriptionTitle);
        });

        setIpQualitySubscriptionPlans(sortedPlans);
      } catch (error) {
        console.error(error);
      }
    };

    fetchIpQualitySubscriptionPlans();
  }, []);

  const handleBuyPlan = (plan) => {
    if (plan.subscriptionTitle === 'Contact Sales') {
      props.openForm(plan._id);
      navigate(`/dashboard/subscription/${plan._id}`);
    } else {
      props.openPurchaseForm(plan._id);
      const encodedSubscriptionId = encodeURIComponent(plan._id);
      const encodedSubscriptionName = encodeURIComponent(plan.subscriptionTitle);
      const encodedSubscriptionAmount = encodeURIComponent(plan.subscriptionAmount);
      navigate(
        `/dashboard/subscription/${encodedSubscriptionId}/${encodedSubscriptionName}/${encodedSubscriptionAmount}`
      );
    }
  };

  return (
    <>
      <Typography variant="h6" sx={{ mt: 2, mb: 2, color: Colors.primary }}>
      IP to Currency and Location Data API Subscription Plans
      </Typography>
      <Grid container spacing={3}>
        {ipQualitySubscriptionPlans &&
          ipQualitySubscriptionPlans.map((plan) => (
            <Grid item xs={12} sm={6} md={4} key={plan._id}>
              <Card
                variant="outlined"
                sx={{
                  borderColor: 'transparent',
                  borderWidth: 1,
                  borderRadius: '8px',
                  transition: '0.3s',
                  height: 380, 
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': {
                    boxShadow: 3,
                    borderColor: Colors.primary,
                  },
                  overflow: 'hidden',
                }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: 1,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {plan.subscriptionTitle}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{ mt: 2, color: Colors.secondary }}
                  >
                    {plan.subscriptionAmount} / {plan.subscriptionDays} days
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {plan.subscriptionDescription}
                  </Typography>

                  <List
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center', 
                      flex: 0.9, 
                      minHeight: 30, 
                    }}
                  >
                    <ListItem sx={{ justifyContent: 'center' }}>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ color: Colors.primary }} />
                      </ListItemIcon>
                      <ListItemText primary={`Hits: ${plan.numberOfHit}`} />
                    </ListItem>
                  </List>

                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      mt: 'auto', 
                      '&:hover': {
                        backgroundColor: 'dark',
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBuyPlan(plan);
                    }}
                  >
                    Buy
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>
    </>
  );
}
